const mobilePath = 'isMob=true'
export function isUserFromMobile(pathName: string = '') {
	return pathName.match(mobilePath)
}
